import React, { useState, useEffect } from "react";
import { TextField, Tabs, Tab } from "@mui/material";
import MainPage from "../_layout/main.page";
import ControlPointOutlinedIcon from "@mui/icons-material/ControlPointOutlined";
import nobrain from "../assets/images/addbrain.png";
import PsychologyOutlinedIcon from "@mui/icons-material/PsychologyOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import LanguageOutlinedIcon from "@mui/icons-material/LanguageOutlined";
import { Link, useNavigate } from "react-router-dom";
import MessageSnackbar from "../_layout/elements/snackbar";
import host from "../host";
import { useDispatch } from "react-redux";
import { changeAuth } from "../actions/loginAction";
import AddBrain from "../components/add-brain";
import TableLoader from "../components/loader/table-loader";
import HeaderPage from "../_layout/elements/header";
import nofolder from "../assets/images/folder.png";
export const ManageBrains = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  //this below function for add brain   popup start//
  const [openaddbrain, setOpendeleteaddbrain] = React.useState(false);
  const activeaddbrain = () => setOpendeleteaddbrain(true);
  const handleCloseaddbrain = () => {
    setOpendeleteaddbrain(false);
    setActiveStep(0);
    setBrainName("");
  };
  //this below function for add brain   popup end//

  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set());
  const isStepOptional = (step) => {
    return step === 1;
  };
  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    if (activeStep === 1 && !brainName.trim()) {
      setSeverity("error");
      setMessage("Brain name cannot be empty");
      setSnackbar(true);
      return;
    }
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const [brainName, setBrainName] = useState("");
  const [brainDescription, setbrainDescription] = useState("");
  const [isPublic, setIsPublic] = useState("");
  const [snackbar, setSnackbar] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const onClose = () => {
    setSnackbar(false);
  };

  const [stepForm, setStepform] = useState("All");
  const [brainList, setBrainList] = useState([]);
  const [selectedList, setSelectedList] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [searchBrainName, setSearchBrainName] = useState("");

  const getbrains = () => {
    setIsLoaded(false);
    let mainquery = "/brain/filter?page=1&limit=100";
    if (searchBrainName !== "") {
      mainquery += `&name=${searchBrainName}`;
    }
    fetch(host.chaturl + mainquery, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 403) {
          dispatch(changeAuth(false, null));
          navigate("/logout");
        } else {
          setIsLoaded(true);
          setSeverity("error");
          setMessage("Something went wrong");
          setSnackbar(true);
        }
      })
      .then((data) => {
        if (data) {
          setBrainList(data.brains);
          setIsLoaded(true);
        }
      })
      .catch((err) => {
        console.log(err);
        setIsLoaded(true);
      });
  };

  useEffect(() => {
    if (brainList.length > 0) {
      const tempList = brainList.filter((brain) => {
        if (brain.status === stepForm) {
          return brain;
        } else if (stepForm === "All") {
          return brain;
        }
      });
      setSelectedList(tempList);
    } else {
      setSelectedList([]);
    }
  }, [brainList, stepForm]);

  //brain - list functionality ends

  useEffect(() => {
    if (!localStorage.getItem("login")) {
      navigate("/logout");
    }
  }, [localStorage.getItem("login")]);

  useEffect(() => {
    getbrains();
  }, []);

  useEffect(() => {
    if (searchBrainName !== "") {
      const delayDebounceFn = setTimeout(() => {
        Promise.all([getbrains()])
          .then(() => {})
          .catch((_error) => {});
      }, 500);
      return () => clearTimeout(delayDebounceFn);
    }
  }, [searchBrainName]);

  useEffect(() => {
    getbrains();
  }, []);

  return (
    <>
      <MainPage>
        <HeaderPage />
        <MessageSnackbar open={snackbar} autoHideDuration={3000} onClose={onClose} severity={severity} message={message} />

        <div className="page_head-top wbtn">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="page_head_top_flex">
                  <div className="page-head-title ">
                    <h5>Manage Brian</h5>
                  </div>
                  <div className="page-head-buttons ">
                    <button type="button" className="btn btn-primary" onClick={activeaddbrain}>
                      <ControlPointOutlinedIcon fontSize="small" />
                      Add Brain
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="page-content">
          <section className="braintabs bg-white">
            <div className="container">
              <div className="row">
                <div className="col-md-6">
                  <Tabs value={value} onChange={handleChange} variant="scrollable" scrollButtons="auto" aria-label="scrollable auto tabs example">
                    <Tab
                      label="All"
                      onClick={() => {
                        setStepform("All");
                      }}
                    />
                    <Tab
                      label="Private"
                      onClick={() => {
                        setStepform("private");
                      }}
                    />
                    <Tab
                      label="Public"
                      onClick={() => {
                        setStepform("public");
                      }}
                    />
                  </Tabs>
                </div>
              </div>
            </div>
          </section>

          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="new-chatform mb-4 mt-4">
                  <TextField
                    id="outlined-multiline-flexible"
                    placeholder="Search for a brain"
                    multiline
                    value={searchBrainName}
                    onChange={(e) => {
                      setSearchBrainName(e.target.value);
                    }}
                  />
                  <div className="search-icon">
                    <SearchOutlinedIcon />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="no_content-wrapper " style={{ display: "none" }}>
            <div className="no-content-box">
              <div className="no_content-icon">
                <img src={nofolder} alt="" height={100} />
              </div>
              <div className="no_content-title">
                {" "}
                Let’s create your first folder on Click on <span className="text-bold600 text-secondry"> Create Folder</span> Button
              </div>
              <div className="no_content-pera">
                <span>Create your folder by clicking on the 'Create Folder' button in the top right corner and get started </span>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                {selectedList && selectedList.length > 0 && isLoaded ? (
                  <div className="brain_flex">
                    {selectedList.map((brain, index) => {
                      return (
                        <div className="brain_cta  " key={index}>
                          <div className="brain_cta">
                            <div className="brain-title">
                              <div className="braintype_icon">
                                <LanguageOutlinedIcon />
                              </div>
                              <h5>{brain.name ? brain.name : "NA"}</h5>
                            </div>
                            <div className="brain_description-box">
                              <span>{brain.description ? brain.description : "NA"}</span>
                            </div>
                            <div className="brain_configur_btn">
                              <Link to={`/brain-setting/${brain.id}`}>
                                <button type="button" className="btn btn-default w-50">
                                  Configure
                                  <PsychologyOutlinedIcon fontSize="small" />
                                </button>
                              </Link>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : isLoaded ? (
                  <div className="no_content-wrapper " style={{ display: "block" }}>
                    <div className="no-content-box">
                      <div className="no_content-icon">
                        <img src={nobrain} alt="" height={100} />
                      </div>
                      <div className="no_content-title">
                        {" "}
                        Let’s create your first. Click on <span className="text-bold600 text-secondry"> Create Folder</span> Button
                      </div>
                      <div className="no_content-pera">
                        <span>Create your folder by clicking on the 'Create Folder' button in the top right corner and get started </span>
                      </div>
                    </div>
                  </div>
                ) : (
                  <TableLoader />
                )}
              </div>
            </div>
          </div>
        </div>

        <AddBrain openaddbrain={openaddbrain} handleCloseaddbrain={handleCloseaddbrain} getbrains={getbrains} />
      </MainPage>
    </>
  );
};
